import { Injectable } from '@angular/core';
import {EeocDataV2, TalentMoatsAvailabilityV2} from "../../../../typings";
import {TalentProfileStartAvailability} from "../../../enums";

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  constructor() { }

  stringToDate(dateString: string): Date | null {
    if(dateString != null && dateString != '') {
      const [year, month, day] = dateString.split('-').map(Number);
      return new Date(year, month - 1, day);
    }
    return null;
  }

  dateToString(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  filterTalentAvailability(availability: TalentMoatsAvailabilityV2): TalentMoatsAvailabilityV2 {
    if(availability.availabilityType == TalentProfileStartAvailability.NOW) {
      availability.availabilityDate= null;
      availability.numWeeksNoticeNeeded= null;
    }
    else if(availability.availabilityType == TalentProfileStartAvailability.WITH_NOTICE) {
      availability.availabilityDate= null;
    }
    else if(availability.availabilityType == TalentProfileStartAvailability.SPECIFIC_DATE) {{
      availability.numWeeksNoticeNeeded= null;
    }}

    return availability;
  }

  filterTalentEeoc(eeocData: EeocDataV2): EeocDataV2 {
    if(eeocData.gender != 8) {
      eeocData.customGender = null;
    }
    if(eeocData.pronouns != 5) {
      eeocData.customPronoun = null;
    }
    return eeocData;
  }


  getDateFormat(localeId: number): string {
    const formats: { [countryId: number]: string } = {
      1: 'MM/dd/yyyy', // USA
      2: 'dd/MM/yyyy', // uk english
      3: 'dd/MM/yyyy', // australia english
      4: 'yyyy/MM/dd', // canada french
      24: 'yyyy/MM/dd', // canada english
      21: 'dd/MM/yyyy', // netherlands english
    };

    return formats[localeId] || 'MM/dd/yyyy';
  }

}
